import { MessengerIcon, type MessengerKind } from './MessengerIcons'
import type { Locale } from '../content/site'

type CommunityLink = {
  kind: MessengerKind
  href: string
  label: Record<Locale, string>
  accessibleLabel: Record<Locale, string>
}

const communityLinks: CommunityLink[] = [
  {
    kind: 'telegram',
    href: 'https://t.me/PayeKooh',
    label: { fa: 'کانال رسمی', en: 'Official channel' },
    accessibleLabel: { fa: 'کانال رسمی تلگرام پایه‌کوه', en: 'Official Payekooh Telegram channel' },
  },
  {
    kind: 'telegram',
    href: 'https://t.me/payekohgp',
    label: { fa: 'گروه تلگرام', en: 'Telegram group' },
    accessibleLabel: { fa: 'گروه تلگرام پایه‌کوه', en: 'Payekooh Telegram community group' },
  },
  {
    kind: 'instagram',
    href: 'https://instagram.com/payekooh',
    label: { fa: 'اینستاگرام', en: 'Instagram' },
    accessibleLabel: { fa: 'صفحه اینستاگرام پایه‌کوه', en: 'Payekooh Instagram profile' },
  },
]

export function PayekoohCommunityLinks({ locale, variant = 'card' }: {
  locale: Locale
  variant?: 'card' | 'detail'
}) {
  return (
    <nav
      className={`payekooh-community payekooh-community--${variant}`}
      aria-label={locale === 'fa' ? 'شبکه‌های اجتماعی پایه‌کوه' : 'Payekooh community links'}
    >
      <div className="payekooh-community__heading">
        <span className="payekooh-community__heading-line" aria-hidden="true" />
        <span>{locale === 'fa' ? 'با جامعه پایه‌کوه همراه شوید' : 'Connect with the Payekooh community'}</span>
      </div>
      <div className="payekooh-community__links">
        {communityLinks.map((item) => (
          <a
            key={item.href}
            className={`payekooh-community__link payekooh-community__link--${item.kind}`}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={item.accessibleLabel[locale]}
            title={item.accessibleLabel[locale]}
          >
            <span className="payekooh-community__icon" aria-hidden="true">
              <MessengerIcon kind={item.kind} />
            </span>
            <span className="payekooh-community__label">{item.label[locale]}</span>
            <span className="payekooh-community__external" aria-hidden="true">↗</span>
          </a>
        ))}
      </div>
    </nav>
  )
}
